<template>
  <nav class="flex flex-wrap items-center justify-between">
    <div class="items-center mr-6 text-white flex-no-shrink">
      <router-link to="/">
        <img src="../../../client/assets/logo-haft.png" alt="logo" />
      </router-link>
    </div>

    <div class="block lg:hidden">
      <div class="block lg:hidden">
        <button
          @click="toggleNav"
          id="nav-toggle"
          class="flex items-center px-3 py-2 rounded transition-all text-grey hover:text-white"
        >
          <svg viewBox="0 0 100 80" width="40" height="40">
            <rect width="80" height="15" />
            <rect y="30" width="80" height="15" />
            <rect y="60" width="80" height="15" />
          </svg>
        </button>
      </div>
    </div>

    <div
      :class="
        `f ${
          !navIsOpen ? 'hidden' : ''
        } w-full pt-6 lg:flex  lg:w-auto lg:block lg:pt-0 animated fadeIn transition-all`
      "
      id="nav-content"
    >
      <ul class="items-center justify-end flex-1 list-reset lg:flex">
        <li>
          <router-link
            @click.native="toggleNav"
            class="block py-2 font-bold transition duration-300 ease-in-out transform sm:px-4 motion-reduce:transform-none hover:-translate-y-1"
            :to="'/'"
            >Strona glówna</router-link
          >
        </li>
        <li>
          <router-link
            @click.native="toggleNav"
            class="block py-2 font-bold transition duration-300 ease-in-out transform sm:px-4 motion-reduce:transform-none hover:-translate-y-1"
            :to="'/o-firmie'"
            >O firmie</router-link
          >
        </li>
        <li>
          <router-link
            @click.native="toggleNav"
            class="block py-2 font-bold transition duration-300 ease-in-out transform sm:px-4 motion-reduce:transform-none hover:-translate-y-1"
            :to="'/oferta'"
            >Oferta</router-link
          >
        </li>
        <li>
          <router-link
            @click.native="toggleNav"
            class="block py-2 font-bold transition duration-300 ease-in-out transform sm:px-4 motion-reduce:transform-none hover:-translate-y-1"
            :to="'/galeria'"
            >Galeria</router-link
          >
        </li>
        <li>
          <router-link
            @click.native="toggleNav"
            class="block py-2 font-bold transition duration-300 ease-in-out transform sm:px-4 motion-reduce:transform-none hover:-translate-y-1"
            :to="'/praca'"
            >Praca</router-link
          >
        </li>
        <li>
          <router-link
            @click.native="toggleNav"
            class="block py-2 font-bold transition duration-300 ease-in-out transform sm:px-4 motion-reduce:transform-none hover:-translate-y-1"
            :to="'/kontakt'"
            >Kontakt</router-link
          >
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  props: ["loggedIn"],
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      navIsOpen: false,
    };
  },
  computed: {
    brand() {
      return process.env.VUE_APP_APPNAME;
    },
    pageTitle() {
      return process.env.VUE_APP_NAME;
    },
    baseUrl() {
      return process.env.VUE_BASE_URL;
    },
  },
  methods: {
    toggleNav() {
      this.navIsOpen = !this.navIsOpen;
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style lang="scss" scoped>
.router-link-exact-active {
  color: #333061;
}
</style>
